export default __webpack_public_path__ + "static/media/course-station.f647055f.PNG";